import React from 'react';
import Select from 'react-select';
import $ from 'jquery';

class SelectClassificacoes extends React.Component {

    constructor(props, context) {
        super(props, context);
        
        this.state = {
            classificacoes: Object.assign({}, props.classificacoes),
            value: '0',
            limparTela: true
        };
       this.getClassificacoesSelecionadas = this.getClassificacoesSelecionadas.bind(this);
    }

 //limpar seleção caso tenha nova manifestação
    componentWillReceiveProps(nextProps) {
        
        if(this.props.limparSelecao && this.state.limparTela){
            this.setState({value: '0'}); 
             this.setState({ limparTela: false});
        }
        if(nextProps.selecinarId !== this.props.selecinarId){
            this.setState({value: nextProps.selecinarId}); 
                                        
        }
    }
    componentDidMount() {
        
           this.setState({ value: this.props.selecinarId}); 
     }

    getClassificacoesSelecionadas(val){
        //console.log('getClassificacoesSelecionadas', val);
        
        this.setState({ value: val});
        this.props.filterme(val);
    }
 
    render() {
        var lis = null;
        
      //console.log('AcaoEncaminhar SelectClassificacoes -> ', this.props.operadoresRepasse);
      if(!$.isEmptyObject(this.props.classificacoes)){
            
        var classificacoes = this.props.classificacoes.filter(function(el) {
            return el.mIdClassificacao !== 1 && el.mVisivelExterno
        })
                lis =  classificacoes.map(p => ( 
                    { value: p.mIdClassificacao.toString(), label: p.mDescricao }
                ));
      }


        return ( 
            <Select multi={this.props.multi} simpleValue  placeholder="Selecione" options={lis} value={this.state.value} onChange={this.getClassificacoesSelecionadas} clearable={false} disabled={this.props.disabled} />
            )
    }
}

SelectClassificacoes.protoType = {
    filterme: React.PropTypes.func.isRequired,
    classificacoes: React.PropTypes.object.isRequired
}


export default SelectClassificacoes;



/** WEBPACK FOOTER **
 ** ./src/components/common/SelectClassificacoes.js
 **/